import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <Loader2 className="w-8 h-8 text-orange animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/accedi" replace />;
  if (role && user.role !== role) return <Navigate to="/accedi" replace />;
  return children;
}
